import poin from "../../assets/img/Group.png";
import "../../style/animations.css";
import { useMemo } from "react";
import { useInView } from "../../hooks/useInView";
import { useHomePage } from "../../context/HomePageContext";
import { useLanguage } from "../../context/LanguageContext";
import { resolveMission, resolveVision } from "../../lib/homePageContent";

export default function VisionMissionSection() {
  const { data } = useHomePage();
  const { language } = useLanguage();
  const vision = useMemo(() => resolveVision(data?.vision, language), [data, language]);
  const mission = useMemo(() => resolveMission(data?.mission, language), [data, language]);

  const { ref: visionRef, inView: visionInView } = useInView<HTMLDivElement>();
  const { ref: missionRef, inView: missionInView } =
    useInView<HTMLDivElement>();

  return (
    <section className="w-full bg-[#C7E5E7] py-16 px-6 lg:px-20">
      <div className="max-w-6xl mx-auto space-y-10">
        {/* VISI */}
        <div
          ref={visionRef}
          className="bg-white rounded-[32px] overflow-hidden shadow-sm">
          <div className="grid lg:grid-cols-2">
            <div
              className={`
                reveal-left
                ${visionInView ? "is-visible" : ""}

                p-8 lg:p-12 flex flex-col justify-center
              `}>
              <h2 className="text-4xl font-bold text-center mb-8">{vision.title}</h2>

              <ul className="space-y-5 text-gray-700">
                {vision.points.map((point, index) => (
                  <li
                    key={index}
                    style={{
                      transitionDelay: visionInView
                        ? `${200 + index * 120}ms`
                        : "0ms",
                    }}
                    className={`
                    reveal-up
                    ${visionInView ? "is-visible" : ""}

                    flex
                    items-start
                    gap-3
                    leading-relaxed
                  `}>
                    <img
                      src={poin}
                      alt=""
                      className="mt-1 h-5 w-5 shrink-0 object-contain"
                    />

                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div
              className={`
                reveal-right
                ${visionInView ? "is-visible" : ""}

                relative h-[300px] lg:h-auto overflow-hidden
              `}>
              <img
                src={vision.image}
                alt="Vision"
                className="
                  w-full h-full object-cover

                  transition-transform
                  duration-[1200ms]
                  ease-out

                  hover:scale-105
                "
              />

              {/* Gradient Figma */}
              <div className="vision-gradient absolute inset-0" />
            </div>
          </div>
        </div>

        {/* MISI */}
        <div
          ref={missionRef}
          className="bg-white rounded-[32px] overflow-hidden shadow-sm">
          <div className="grid lg:grid-cols-2">
            <div
              className={`
                reveal-left
                ${missionInView ? "is-visible" : ""}

                relative h-[300px] lg:h-auto order-2 lg:order-1 overflow-hidden
              `}>
              <img
                src={mission.image}
                alt="Mission"
                className="
                  w-full h-full object-cover

                  transition-transform
                  duration-[1200ms]
                  ease-out

                  hover:scale-105
                "
              />

              {/* Gradient Figma */}
              <div className="mission-gradient absolute inset-0" />
            </div>

            <div
              className={`
                reveal-right
                ${missionInView ? "is-visible" : ""}

                p-8 lg:p-12 flex flex-col justify-center order-1 lg:order-2
              `}>
              <h2 className="text-4xl font-bold text-center mb-8">{mission.title}</h2>

              <ul className="space-y-5 text-gray-700">
                {mission.points.map((point, index) => (
                  <li
                    key={index}
                    style={{
                      transitionDelay: missionInView
                        ? `${200 + index * 120}ms`
                        : "0ms",
                    }}
                    className={`
                    reveal-up
                    ${missionInView ? "is-visible" : ""}

                    flex
                    items-start
                    gap-3
                    leading-relaxed
                  `}>
                    <img
                      src={poin}
                      alt=""
                      className="mt-1 h-5 w-5 shrink-0 object-contain"
                    />

                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
